export const infinityButNumber = 9999999999;
